import './Home.css';
import '../index.css';
import Countdown from '../components/Countdown';

function Home() {
    return (
        <div className='home-main'>
            <div className='home-main-text'>Ida & Jakob</div>
            <div className='home-text'>Lillegård, Kävlinge - Onsdag 30/6 2027</div>
            <div className='image-container'>
                <img rel="prefetch" as="image" src="/homePicture.png" alt="main-picture" />
            </div>
            <Countdown targetDate={"2027-06-30T14:00:00Z"} />
        </div >
    );
}

export default Home;
